import { Default } from './passwordStrength.default'
import { IPasswordStrength } from './types'

const PasswordStrength = (props: IPasswordStrength) => <Default {...props} />

PasswordStrength.Default = Default

export default PasswordStrength
